<script lang="ts" setup>
import { type UboMetCheckResultaat } from '@relatie-lib/ubo/types';
import { hasPermission } from '@permission/hasPermission';
import VModal from '@shared/component/VModal/VModal.vue';
import { useUboForceerResultaat } from '@services/crm-public/orval-api/ubo/ubo';
import { useWatchErrorHandler } from '@errors/useErrorHandler';
import { uboContextInjectionKey } from '@relatie-lib/ubo/keys';
import { inject, unref } from 'vue';

const ubo = defineModel<UboMetCheckResultaat>({ required: true });
const isOpen = defineModel<boolean>('isOpen', { required: true });

const magResultaatOverschrijven = hasPermission('Crm.UboResultaatOverschrijven');

const uboContext = inject(uboContextInjectionKey);

const { mutate: forceerResultaat, error } = useUboForceerResultaat({
  mutation: {
    onSuccess: () => {
      ubo.value.resultaat = 'Goedgekeurd';
      isOpen.value = false;
    },
  },
});
useWatchErrorHandler(error);

function resultaatOverschrijven() {
  if (!magResultaatOverschrijven) {
    return;
  }
  forceerResultaat({
    uboId: ubo.value.id,
    data: { resultaat: 'Goedgekeurd', uboContext: unref(uboContext?.value) ?? 'Algemeen' },
  });
}
</script>

<template>
  <VModal
    title="UBO goedkeuren?"
    confirm-button-text="Goedkeuren"
    @close-modal="isOpen = false"
    @confirm-action="resultaatOverschrijven"
    @cancel-button-clicked="isOpen = false"
    :is-active="isOpen"
    :size="'xs'"
  >
    <p>
      <strong>Let op:</strong> Als je deze UBO goedkeurt kun je dit niet meer ongedaan maken. Weet
      je het zeker?
    </p>
  </VModal>
</template>
